import patch1 from "../images/patch1.jpeg"
import patch2 from "../images/patch2.jpeg"
import patch3 from "../images/patch3.jpeg"
import { ChevronDown } from "lucide-react";
import { useState } from "react";








  const faqs = [
    {
      id: 1,
      question: "How long should we plan to spend at the farm to do all the activities?",
      answer:
        "1-2 hours depending",
    },
      {
      id: 2,
      question: "If entry is free, why do I need a ticket?",
      answer:
        "✨ Entry to Sidhu Farms is always free! Come shop for pumpkins, enjoy our farm stand, and order homemade Indian food with no ticket required. 🎟 Tickets are only needed for special attractions. When you buy a ticket, you’ll get a wristband that gives you access to the corn maze, hayrides, kids play area, and 5 slingshots. The wristband also lets you skip the lines! If you purchase activities individually at the farm, they will cost more and may have wait times. The all-inclusive wristband is the best value if you want to enjoy all the attractions without the hassle. Ticket Pricing: •Adults: $18 (Mon–Thurs $17) •Children: $16 (Mon–Thurs $15) Your ticket helps us staff and maintain these experiences so everyone can enjoy them safely and to the fullest.",
    },
    {
        id: 3,
        question: "Is there free parking?",
        answer:
          "YES",
      },
      {
        id: 4,
        question: "Can we get pumpkins for carving?",
        answer:
          "YES! We have a huge selection of pumpkins of all sizes and perfect for carving. We also have beautiful selections of decorative gourds and winter squashes. We grow without pesticides and chemicals so many varieties are wonderful to eat or and perfect pumpkin seeds for roasting. ",
      },
      {
        id: 5,
        question: "What should we wear?",
        answer:
          "It's a farm, so be prepared for mud, especially on rainy days, and dress for the weather. ",
      },
      {
        id: 6,
        question: "Can we get food there?",
        answer:
          "Yes! There are multiple food options: food trucks, Indian food and fall carnival concessions. ",
      },
      {
        id: 7,
        question: "What's the latest time of entry?",
        answer:
          "5:30 pm but try to come earlier to enjoy more fun. ",
      },
    // More questions...
  ]

  
  export default function PumpkinPage2() {

      const [openIndex, setOpenIndex] = useState(null);

        const toggleFAQ = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

    return (
      <div className="bg-[#101010] ">
               <p className="text-2xl sm:text-3xl px-2 pt-6 sm:pt-10 font-semibold leading-snug text-center m-auto text-[#ffa500]">
  SIDHU FARMS PUMPKIN PATCH
</p>

<div className="p-4 sm:p-6 md:p-8 border border-[#ed4811] m-4 sm:m-6 md:m-8 rounded-xl">

  <p className="text-white px-4 sm:px-6 md:px-8 py-3 text-base sm:text-lg text-center m-auto leading-relaxed">
    ✨ Entry to Sidhu Farms is always free! Come shop for pumpkins, enjoy our farm stand, and order homemade Indian food with no ticket required.

🎟 Tickets are only needed for special attractions.

When you buy a ticket, you’ll get a wristband that gives you access to the corn maze, hayrides, kids play area, and 5 pumpkin slingshots. 

Lines for individual attractions can get long—but with an All-Inclusive Ticket, your wristband gives you direct access without the wait.

If you purchase activities individually at the farm, they will cost more and may have wait times. The all-inclusive wristband is the best value if you want to enjoy all the attractions without the hassle.


Your ticket helps us staff and maintain these experiences so everyone can enjoy them safely and to the fullest.


  </p>

  <p className="text-[#ffa500] px-4 sm:px-6 md:px-8 py-2 text-base sm:text-lg text-center m-auto font-semibold">
    Ticket Pricing: <br />
    Adults: $18 (Mon–Thurs $17)<br />
    Children: $16 (Mon–Thurs $15)<br />
    Your ticket helps us staff and maintain these experiences so everyone can enjoy them safely and to the fullest.
  </p>

  <div className="flex justify-center">
    <a
      href="https://sidhufarms.ticketspice.com/the-sidhu-farms-pumpkin-patch-page"
      target="_blank"
      className="mt-6 py-2 px-6 text-white text-lg sm:text-xl rounded-full bg-[#ed4811] hover:bg-yellow-400 hover:text-[#191919] transition duration-150 ease-in-out"
    >
      Buy Ticket
    </a>
  </div>
</div>

        
        <div className="mx-auto max-w-7xl px-6 lg:px-8">
          <div className="mx-auto grid max-w-2xl grid-cols-1 items-start gap-x-8 sm:gap-y-24 lg:mx-0 lg:max-w-none lg:grid-cols-2">
            <div className="lg:pr-4">
              <div className="relative overflow-hidden rounded-md  px-6  pt-64 shadow-2xl sm:px-12 lg:max-w-lg lg:px-8 lg:pb-32 xl:px-10  brightness-125 ">
                <img
                  alt=""
                  src={patch2}
                  className="absolute inset-0 h-auto w-full object-cover "
                />
             
               
              
              </div>
              
            </div>
            <div>
              
              <div className="text-base leading-7 text-[#ffa500] lg:max-w-lg ">
                <h1 className=" text-3xl font-bold tracking-tight text-gray-900 sm:text-4xl mt-8">
                  <span id="friz" class="italic text-[#ed4811] ">Lochness Monster! </span> <br></br>Themed Corn Maze
                </h1>

                <dl className="mt-4 grid text-lg  text-white gap-2 border-[#ed4811] border-b border-t pt-2 pb-2  ">
               <ul class=" grid grid-cols-1 lg:grid-cols-1 gap-4  list-inside">
                <li class="text-[#ffa500] font-semibold">*Lochness Monster! Corn Maze</li>
                <li>Pumpkins! Pumpkins! Pumpkins!</li>
                <li class="text-[#ffa500] font-semibold">*Hay rides on Sidhu’s Tractor Train</li>
                <li>Indian Food Truck</li>
                <li>Farm Stand Grocery</li>
                <li class="text-[#ffa500] font-semibold">*Kid’s Playground & Bouncy House</li>
                <li>Concessions & Roasted Corn</li>
                <li>Kettle Corn & Hot Dogs</li>
                <li class="text-[#ffa500] font-semibold">*Five Pumpkin Slingshots</li>
                <li>Cool Photo Backdrops</li>
                <li>Giant Skeletons</li>
               </ul>
              </dl>
              <h4 class="text-[#ffa500] text-lg pt-2 font-semibold">*Ticket Required (one ticket includes all these activities)</h4>

                
              </div>
             
            </div>

            
            
            <div className="max-w-xl text-lg text-[#ffa500]">

                
                  <p className="">
                  Sidhu Farms Pumpkin Patch is Super kid friendly with tons of activities for the littles, middles, big kids, and young-at-heart grown ups, that are ready for some seriously spooky fall fun!
                  </p>
                  <p className="mt-8">
                  We have a real pumpkin patch where we grow all of the pumpkins on our farm. In fact, we grow over 50 varieties of pumpkins, winter squashes and gourds for carving, decorating and even eating!! 

                  </p>
                  <p className="mt-8">
                  Enjoy family fun Hayrides on the signature Sidhu Farms style tractor train, giant festive halloween skeletons, kids playground, bouncy houses and games, delicious food options, and of course, a patch to pick your favorite halloween pumpkin! 
                  </p>

                  <h1 class="mt-8 mb-8"> 
                  <span id="friz" class="italic lg:text-4xl text-3xl ">Adults: $18 (Mon–Thurs $17)<br></br>Children: $16 (Mon–Thurs $15)</span>         
                  </h1>

                </div>
                <div class="  lg:max-w-lg lg:pb-8 " >
                    <img
                  alt=""
                  src={patch3}
                  className=" inset-0  rounded-md  h-full w-full object-cover brightness-125 "
                />
                </div>
            
          </div>
        </div>

   
  <section className="w-full max-w-2xl mx-auto p-4 sm:p-6 lg:p-8">
      <h2 className="text-2xl text-white sm:text-3xl mt-10 font-bold text-center mb-6">
        Frequently Asked Questions
      </h2>
      <div className="space-y-4">
        {faqs.map((faq, index) => (
          <div
            key={index}
            className="  "
          >
            <button
              onClick={() => toggleFAQ(index)}
              className="w-full flex justify-between text-black bg-[#ffa500] items-center p-4 text-left"
            >
              <span className="font-medium text-gray-800 text-base sm:text-lg">
                {faq.question}
              </span>
              <ChevronDown
                className={`w-5 h-5 text-gray-500 transition-transform duration-300 ${
                  openIndex === index ? "rotate-180" : ""
                }`}
              />
            </button>
            {openIndex === index && (
              <div className="px-4 pb-4 text-white mt-6 text-sm sm:text-base">
                {faq.answer}
              </div>
            )}
          </div>
        ))}
      </div>
    </section>


      </div>
    )
  }
  